import { AsyncDropdown } from "src/app/models/async-dropdown";

export class NejoData {
    identifier: string;
    name: string;
    link: string;
    code: string;
    source: string;
    customer: AsyncDropdown;
    modifiedAt: string;
    createdAt: string;
    offer: string;
    ownerSales: string;
    ownerPresales: string;
    ownerOrderManagement: string;
    ownerOperationsManager: string;
    owner: string;
    orderStatus: AsyncDropdown;
    lob: AsyncDropdown;
    pillar: AsyncDropdown;
    solution: AsyncDropdown;
    type: AsyncDropdown;
    department: AsyncDropdown;
    opportunity: AsyncDropdown;
    tags: any;
    ownerHandler: string;
    bo: any;
  }